import { render, staticRenderFns } from "./CytologyResult.vue?vue&type=template&id=6aed6ec2&scoped=true&"
import script from "./CytologyResult.vue?vue&type=script&lang=js&"
export * from "./CytologyResult.vue?vue&type=script&lang=js&"
import style0 from "./CytologyResult.vue?vue&type=style&index=0&id=6aed6ec2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aed6ec2",
  null
  
)

export default component.exports